import { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate, Link } from "react-router-dom";
import { Spark } from "../components/Spark";
import { LOGIN } from "../constants/testIds";
import { ArrowRight, Loader2 } from "lucide-react";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(email, password);
    setBusy(false);
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground flex items-center justify-center p-6 relative overflow-hidden">
      {/* ambient violet glows */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/4 left-1/4 h-[400px] w-[400px] rounded-full bg-violet-600/20 blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 h-[350px] w-[350px] rounded-full bg-fuchsia-600/15 blur-[120px]" />
      </div>

      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center gap-3 mb-10">
          <Link to="/"><Spark className="h-14 w-14" /></Link>
          <div className="text-center">
            <h1 className="text-3xl font-bold tracking-tight">Bem-vindo de volta</h1>
            <p className="mt-1.5 text-sm text-muted-foreground">Entra pra continuar estudando</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-border bg-card p-6">
          <div className="space-y-1.5">
            <label className="text-xs font-medium tracking-wide text-muted-foreground uppercase">Email</label>
            <input
              data-testid={LOGIN.emailInput}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg bg-secondary px-4 py-3 text-sm outline-none ring-0 focus:ring-2 focus:ring-violet-500/50 transition"
              placeholder="voce@email.com"
              required
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-medium tracking-wide text-muted-foreground uppercase">Senha</label>
            <input
              data-testid={LOGIN.passwordInput}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg bg-secondary px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-violet-500/50 transition"
              placeholder="••••••••"
              required
            />
          </div>
          {error && (
            <div data-testid="login-error-msg" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid={LOGIN.submitButton}
            disabled={busy}
            className="w-full flex items-center justify-center gap-2 rounded-full bg-violet-600 hover:bg-violet-500 text-white font-medium py-3 transition-all disabled:opacity-60 glow-violet"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Entrar <ArrowRight className="h-4 w-4" /></>}
          </button>
        </form>
        <p className="text-center text-xs text-muted-foreground mt-6">
          Não tem conta?{" "}
          <Link data-testid={LOGIN.registerLink} to="/cadastro" className="text-violet-400 hover:text-violet-300 font-medium">
            Cadastre-se grátis
          </Link>
        </p>
      </div>
    </div>
  );
}
